import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import CategoryTabs from '@/components/feature/CategoryTabs';
import Sidebar from '@/components/feature/Sidebar';
import { categories, getCategoryBySlug } from '@/mocks/categories';
import { getArticlesByCategory } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const activeSlug = slug || categories[0].slug;
  const currentCategory = getCategoryBySlug(activeSlug);
  const categoryArticles = getArticlesByCategory(activeSlug);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: currentCategory ? `${currentCategory.name} - 海角论坛` : '板块 - 海角论坛',
    description: currentCategory?.description || '',
    url: `https://haijiao.com/category/${activeSlug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '海角论坛',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200/70">
          <div className="container-custom py-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: currentCategory?.name || '板块' },
              ]}
            />
          </div>
        </div>

        <div className="bg-background-50 border-b border-background-200/70">
          <div className="container-custom py-6">
            <div className="flex items-center gap-4 mb-1">
              {currentCategory && (
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${
                  currentCategory.color === 'primary' ? 'bg-primary-100 text-primary-600' : 'bg-accent-100 text-accent-600'
                }`}>
                  <i className={`${currentCategory.icon} text-xl`}></i>
                </div>
              )}
              <div>
                <h1 className="text-2xl font-bold text-foreground-950 font-heading">
                  {currentCategory?.name || '板块'}
                </h1>
                <p className="text-sm text-foreground-600 mt-0.5">
                  {currentCategory?.description}
                  <span className="ml-3 text-foreground-400">
                    {currentCategory?.articleCount.toLocaleString()} 篇帖子 · 今日 {currentCategory?.todayPosts} 篇
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div className="container-custom pb-4">
            <CategoryTabs categories={categories} activeCategory={activeSlug} />
          </div>
        </div>

        <div className="container-custom py-8">
          <div className="flex flex-col lg:flex-row gap-8">
            <div className="flex-1 min-w-0">
              {categoryArticles.length > 0 ? (
                <div className="space-y-4">
                  {categoryArticles.map((article) => (
                    <ArticleCard key={article.id} {...article} />
                  ))}
                </div>
              ) : (
                <div className="text-center py-20">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-background-100 rounded-full">
                    <i className="ri-inbox-line text-2xl text-foreground-400"></i>
                  </div>
                  <p className="text-foreground-500">该板块暂无文章</p>
                  <Link to="/" className="text-sm text-primary-600 hover:text-primary-700 mt-2 inline-block">
                    返回首页
                  </Link>
                </div>
              )}
            </div>
            <div className="w-full lg:w-[320px] flex-shrink-0">
              <Sidebar />
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}